import React, {createRef} from 'react'

export class FxaPrompt extends React.Component {
  
  constructor(props) {
    super(props);
    this.formRef = createRef();
    this.migrateRef = createRef();
  }

  componentDidMount() {
    snowplow('enableFormTracking')
  }

  render() {
    const { dict, route } = this.props

    const handleUpgrade = () => {
      this.migrateRef.current.value = 'yes'
    }

    const handleDefer = () => {
      this.migrateRef.current.value = 'defer'
    }

    const handleSubmit = () => {
      this.formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      )
    }
    
    return (
      <div className="fxa-container coreform-container loginform-container">
        <h2>{dict.fxaSwitchTo}</h2>
        <p>{dict.fxaSwitchDetails}</p>
        <form ref={this.formRef} action="/fxa_upgrade_process" id="fxa-upgrade-form" method="post">
          <input ref={this.migrateRef} type="hidden" name="fxa-migrate" value="defer"/>
          <button className="primary" onClick={handleUpgrade}>{dict.fxaUpgrade}</button>
          <button className="secondary" onClick={handleDefer}>{dict.fxaUpgradeNotYet}</button>
        </form>
        <div className="fxa-divider" />
        <div className="fxa-footer">{dict.fxaUpgradeRequirement}</div>
      </div>
    )
  }
}
